/**
 * @param {{ subTasksMatched?: number, subTasksModified?: number, timeBlocksMatched?: number, timeBlocksModified?: number }} counts
 * @param {{ future?: boolean, futureContext?: 'reopen' | 'close' }} [options] - When future is true, use for confirm previews; futureContext adjusts empty copy.
 */
export function formatChildCascadeLines(
  {
    subTasksMatched,
    subTasksModified,
    timeBlocksMatched,
    timeBlocksModified,
  },
  options = {}
) {
  const { future = false, futureContext = 'reopen' } = options;
  const lines = [];
  const subTotal = Number(subTasksMatched || 0) || 0;
  const subMod = Number(subTasksModified || 0) || 0;
  const tbTotal = Number(timeBlocksMatched || 0) || 0;
  const tbMod = Number(timeBlocksModified || 0) || 0;

  if (subTotal > 0) {
    lines.push(
      future
        ? `Sub-tasks: ${subMod} will be updated (of ${subTotal} total)`
        : `Sub-tasks: ${subMod} updated (of ${subTotal} total)`
    );
  }
  if (tbTotal > 0) {
    lines.push(
      future
        ? `Time blocks: ${tbMod} will be updated (of ${tbTotal} total)`
        : `Time blocks: ${tbMod} updated (of ${tbTotal} total)`
    );
  }
  if (lines.length === 0) {
    if (future) {
      lines.push(
        futureContext === 'close'
          ? 'No related sub-tasks or time blocks to close.'
          : 'No related sub-tasks or time blocks to restore.'
      );
    } else {
      lines.push('No related sub-tasks or time blocks.');
    }
  }
  return lines;
}

